import { ca } from '@cian/analytics';

export const trackBookingButtonShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Show_sopr',
    category: 'Card',
    label: 'booking_button',
    useLastProducts: true,
    page: {
      extra: {
        gallery: true,
      },
    },
  });
};
